// extracted by mini-css-extract-plugin
export default {"arrow":"backArrowButton_arrow__SJhNx"};